import gql from 'graphql-tag';

export const createFile = gql`
  mutation createFile(
    $fileName: String!
    $fileExtension: String!
    $contentType: String!
  ) {
    createFile(
      fileName: $fileName
      fileExtension: $fileExtension
      contentType: $contentType
    ) {
      uuid
      signedUrl
    }
  }
`;

export const getFile = gql`
  query getFile($uuid: String!) {
    getFile(uuid: $uuid) {
      fileName
      fileExtension
      signedUrl
    }
  }
`;
